// to add a new file drop the icon into react-project/public/icons then
// add it to the below object. The key position is the lovely English
// name of the icon, and the value position is the filename itself.
const icons = {
  'Blender3D': 'blender.png',
  'Deepnight': 'deepnight.png',
  'Ferris': 'ferris-happy.svg',
  'Firefox': 'firefox.svg',
  'GDC': 'gdc.svg',
  'Gamasutra': 'gamasutra.ico',
  'Github': 'github.png',
  'Godot': 'godot.png',
  'Itch.io': 'itchio.png',
  'Safari': 'safari.png',
  'Swift': 'swiftlang.svg',
  'YouTube': 'youtube.svg',
};

export default icons;
